import { WEB_FONTS } from "@career/core/constants/web-fonts.constant";

export const ConfigMessages = {
  headers: {
    GLOBAL: "Global Configurations",
    REGISTER: "Register Configurations",
    JOBS: "Jobs Configurations",
    DASHBOARD: "Dashboard Configurations",
    HOME: "Home Configurations",
    STATIC_PAGE: "Static Page Configurations",
    NAV: "Navigation Configurations",
    FOOTER: "Footer Configurations"
  },
};

export const Translations = {
  JOBS_CONFIG: "Jobs Config",
  REGISTER_CONFIG: "Register Config",
  DASHBOARD_CONFIG: "Dashboard Config",
  GLOBAL_CONFIG: "Global Config",
  HOME_CONFIG: "Home Config",
  NAV_CONFIG: "Nav Config",
  FOOTER_CONFIG: "Footer Config",
  STATIC_PAGE_CONFIG: "Static Page Config",
  TEMPLATE_SETTINGS: "Template Settings",
  FONT_FAMILY: "Font Family",
  TEMPLATE: "Template",
  NO_ACCESS_HOME_PAGE: "Portal doesn't have the home page configuration",
  FORWARD_PAGE_MSG: "Organization has an external job search page URL:",
  NO_ACCESS_JOB_SEARCH_PAGE:
    "Portal doesn't have the job search page configuration",
  NO_ACCESS_REGISTER_PAGE:
    "Portal doesn't have the register page configuration",
  ADMIN_QUESTIONS_HEADER: "Questionnaire",
  FAVICONS: "Favicons",
  COLORS: "Colors",
};

export const SliderConfigs = {
  GLOBAL: [
    {
      type: "slider",
      key: "smoothScrolling",
      question: "Enable smooth scrolling effect?",
    },
    {
      type: "slider",
      key: "disablePortalVerification",
      question: "Disable verification email?",
    },
    {
      type: "slider",
      key: "enableReviewDetails",
      question:
        "Enable moving candidate to 'Pending Review' upon registration?",
    },
    {
      type: "slider",
      key: "disableJobSearchPage",
      question: "Disable job search page?",
    },
    {
      type: "slider",
      key: "disableRegisterPage",
      question: "Disable register page?",
    },
    {
      type: "slider",
      key: "enableTalentCta",
      question: "Display Talent CTA?",
    },
    {
      type: "slider",
      key: "enableTalentVideo",
      question: "Display YouTube video and Talent Video Heading?",
    },
    {
      type: "slider",
      key: "disableSignIn",
      question: "Disable sign in?"
    },
    {
      type: "slider",
      key: "disableCareerLevelFilter",
      question: "Disable job search career level filter?",
    },
    {
      type: "slider",
      key: "disableJobLabelFilter",
      question: "Disable Job Label filter?",
    },
    {
      type: "slider",
      key: "disableCompensationFilter",
      question: "Disable job search compensation filter?",
    },
    {
      type: "input",
      key: "agencyWebsite",
      question: "Does organization have an external homepage?",
    },
    {
      type: "input",
      key: "forwardJobSearchPage",
      question: "Does organization have an external job search page URL?",
    },
    {
      type: "select",
      key: "questionnaire",
      question: "Provide an optional registration questionnaire",
    },
    {
      type: "input",
      key: "googleTagManagerId",
      question: "Google Tag Manager ID"
    },
    {
      type: "input",
      key: "logoSize",
      question: "Max Navigation Logo Width (in px)"
    },
    {
      type: "input",
      key: "footerSize",
      question: "Max Footer Logo Width (in px)"
    },
    {
      type: "slider",
      key: "shortLocations",
      question: "Use Shortened Locations (e.g. New York, NY, USA)"
    },
    {
      type: "slider",
      key: "showPostedDate",
      question: "Show posted date on job listings and detail?"
    }
  ],
  NAV: [
    {
      type: "slider",
      key: "showBanner",
      question: "Show info banner?"
    },
    {
      type: "rich-text",
      key: "bannerText",
      question: "Info banner text",
      visibleWhen: {
        key: "showBanner",
        value: true
      }
    },
    {
      type: "color",
      key: "navBackgroundColor",
      question: "Navigation Bar Background Color"
    },
    {
      type: "color",
      key: "navTextColor",
      question: "Navigation Bar Link Color"
    },
    {
      type: "color",
      key: "navActiveTextColor",
      question: "Navigation Bar Active Link Color"
    }
  ],
  FOOTER: [
    {
      type: "color",
      key: "footerBackgroundColor",
      question: "Footer Background Color"
    },
    {
      type: "color",
      key: "footerTextColor",
      question: "Footer Text Color (headings and legal text)"
    },
    {
      type: "color",
      key: "footerLinkColor",
      question: "Footer Link Color"
    },
    {
      type: "textarea",
      key: "footerCookiesText",
      question: "Footer Cookies Text (leave blank for the default privacy notice)"
    },
    {
      type: "textarea",
      key: "footerCopyrightText",
      question: "Footer Copyright Text (leave blank for the default; {year} inserts the current year)"
    }
  ],
  REGISTER: [
    {
      type: "slider",
      key: "collectFullAddress",
      question: "Does organization want to collect full candidate address?",
    },
    {
      type: "slider",
      key: "disableResumeRegistration",
      question:
        "Does organization want to disable collecting candidate resumes?",
    },
    {
      type: "slider",
      key: "requirePhoneNumber",
      question: "Does organization want to collect phone number ?",
    },
  ],
  DASHBOARD: [
    {
      type: "slider",
      key: "enableAvailability",
      question: "Enable candidate availability on the dashboard?",
    },
    {
      type: "slider",
      key: "enableSkills",
      question: "Enable candidate skills display on the dashboard?",
    },
    {
      type: "slider",
      key: "hideAttachedFiles",
      question: "Hide attached files for candidates?"
    },
    {
      type: "slider",
      key: "enableSuggestions",
      question: "Does organization want to enable candidate suggested jobs?",
    },
    {
      type: "slider",
      key: "requireAvailability",
      question: "Enable warning if candidate doesn't provide availability?",
    },
    {
      type: "slider",
      key: "requireResume",
      question: "Enable warning if candidate doesn't provide resume?",
    },
    {
      type: "slider",
      key: "requireSkills",
      question: "Enable warning if candidate skills are not provided?",
    },
  ],
  JOBS: [
    {
      type: "slider",
      key: "hideClient",
      question: "Hide client name from jobs / applications?",
    },
    {
      type: "slider",
      key: "showOpportunityFiles",
      question: "Display attached files for download on opportunity?",
    },
    {
      type: "slider",
      key: "enableInviteMessage",
      question: "Display invite message on invited opportunities?"
    },
    {
      type: "slider",
      key: "referFriends",
      question: "Display Refer Friends button?"
    },
    {
      type: "input",
      key: "inviteMessageTitle",
      question: "Invite message title",
      visibleWhen: {
        key: "enableInviteMessage",
        value: true,
      },
    },
    {
      type: "textarea",
      key: "inviteMessageBody",
      question: "Invite message body",
      visibleWhen: {
        key: "enableInviteMessage",
        value: true,
      },
    },
  ],
  HOME: [
    {
      type: "slider",
      key: "enableHomePage",
      question: "Will this portal have a configured homepage?",
    },
    {
      type: "slider",
      key: "enableAboutSections",
      question: "Show About image and text sections on the home page? (Sky template)",
    },
    {
      type: "input",
      key: "heroImageMaxWidth",
      question: "Hero image max width, e.g. 50% or 600px (Sky template; blank = image's natural size)",
    },
    {
      type: "slider",
      key: "useThemeGlow",
      question: "Use a glow in the portal's theme colors behind the hero instead of the default glow image? (Sky template)",
    },
    {
      type: "input",
      key: "youtubeEmbed",
      question: "YouTube embed URL (full embed URL from YouTube)",
      visibleWhen: {
        key: "template",
        value: "sky"
      }
    },
  ]
};

export const FontFamilyConfig = [
  // Uses the template's own default font (portal_templates.configuration.defaultFontFamily, merged into
  // the portal configuration); Noto Sans when the template has none. See FontService.setFont.
  {
    name: "Template Default",
    value: "template-default",
  },
  {
    name: "Noto Sans",
    value: "noto-sans",
  },
  {
    name: "Montserrat",
    value: "montserrat",
  },
  {
    name: "Inter",
    value: "inter",
  },
  ...WEB_FONTS.map(({ name, value }) => ({ name, value })),
];


